import { NgModule } from "@angular/core";
import { EffectsModule } from "@ngrx/effects";
import { StoreModule } from "@ngrx/store";
import { UserToBillEffect } from "./effect";
import { UserToBillReducer } from "./reducer";

@NgModule({
    imports: [
        EffectsModule.forFeature([UserToBillEffect]),
        StoreModule.forFeature('userToBill', UserToBillReducer)
    ]
})

export class UserToBillStoreModule { }

export const userToBillList = (store: any) => store && store.userToBill && store.userToBill.userToBillList;
export const saveUserToBillResp = (store: any) => store && store.userToBill && store.userToBill.saveUserToBillResp;
export const deleteUserToBillResp = (store: any) => store && store.userToBill && store.userToBill.deleteUserToBillResp;
